import { faFileInvoice, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBRow,
} from "mdbreact";
import React from "react";
import { AppBar, Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import "../css/scrollbar.css";
const PrintInvoice = (props) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  function generateString(length) {
    let result = " ";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  const id = generateString(15);
  const sPreview =
    props.apiServerHybrid +
    "MPrint/ORPrint?reporttype=invoice&code=" +
    props.parentcode +
    "&uc=" +
    sessionStorage.getItem("msal.uc") +
    "&preview=" +
    id +
    "&it=service";
  const sPreviewSales =
    props.apiServerHybrid +
    "MPrint/ORPrint?reporttype=invoice&code=" +
    props.parentcode +
    "&uc=" +
    sessionStorage.getItem("msal.uc") +
    "&preview=" +
    id +
    "&it=sales";
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));
  const classes = useStyles();

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
        className="p-0 m-0"
      >
        {value === index && (
          <Box p={0} m={0}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const TabSales = () => {
    return (
      <>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          aria-label="scrollable"
          // className="cloudy-knoxville-gradient black-text"
          style={{ borderColor: "white" }}
          className="pb-0 mb-0"
        >
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                Sales
                <br />
                Invoice
              </a>
            }
            icon={
              <FontAwesomeIcon icon={faPrint} size="4x" className="blue-text" />
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                Service
                <br />
                Invoice
              </a>
            }
            icon={
              <FontAwesomeIcon icon={faPrint} size="4x" className="blue-text" />
            }
            {...a11yProps(1)}
          />
        </Tabs>
      </>
    );
  };

  return (
    <MDBCard>
      <MDBCardHeader className="cloudy-knoxville-gradient">
        <MDBRow>
          <MDBCol md="8">
            {" "}
            <span
              className="h5-responsive blue-text"
              style={{
                fontFamily: "Montserrat",
                fontWeight: "400",
              }}
            >
              <span className="blue-text">
                <FontAwesomeIcon icon={faPrint} />
              </span>
              &nbsp;Invoice
            </span>
          </MDBCol>
          <MDBCol md="4" className="text-right"></MDBCol>
        </MDBRow>
      </MDBCardHeader>
      <TabSales />
      <hr />

      <MDBCardBody>
        <TabPanel value={value} index={0}>
          <div>
            <a
              href={sPreviewSales}
              target="_blank"
              className="brown-text font-weight-bold"
              title="Print in New Window"
            >
              <FontAwesomeIcon icon={faPrint}> </FontAwesomeIcon>&nbsp;Print in
              New Window
            </a>
          </div>
          <div
            className="embed-responsive embed-responsive-21by9"
            style={{ minHeight: "1200px" }}
          >
            <iframe
              className="embed-responsive-item"
              src={sPreviewSales}
              //   allowfullscreen
            ></iframe>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div>
            <a
              href={sPreview}
              target="_blank"
              className="brown-text font-weight-bold"
              title="Print in New Window"
            >
              <FontAwesomeIcon icon={faPrint}> </FontAwesomeIcon>&nbsp;Print in
              New Window
            </a>
          </div>
          <div
            className="embed-responsive embed-responsive-21by9"
            style={{ minHeight: "1200px" }}
          >
            <iframe
              className="embed-responsive-item"
              src={sPreview}
              //   allowfullscreen
            ></iframe>
          </div>
        </TabPanel>
      </MDBCardBody>
    </MDBCard>
  );
};

export default PrintInvoice;
